import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDocumentReferenceProductDTO, IDocumentResponseDTO } from '@app/core/model';
import { DocumentsContextService } from '@app/core/services/context/factory';
import { SharedDocumentsUploadService } from '@app/shared/services/shared-documents-upload.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsUploadHHService extends SharedDocumentsUploadService {
  constructor(
    http: HttpClient,
    shellService: ShellService,
  ) {
    super(http, shellService, ProductNames.HomeHealth);
  }

  override manageForbiddenDocumentType(
    documents: IDocumentResponseDTO[], 
    documentsContextService: DocumentsContextService,
    documentTypes: IDocumentReferenceProductDTO[],
    authorizationStatus: string,
    productName: string,
    manageForbbidenDocumentType: any,
  ): Observable<IDocumentReferenceProductDTO[]> {
    return of(documentTypes);
  }
}